import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import axiosInstance from '@/lib/axios-instance';
import showToast from '@/lib/helpers/show-toast';
import { API_ROUTES } from '@/lib/routes/api-routes';

const logoutUser = async () => {
  await axiosInstance.post(API_ROUTES.auth.logout);
};

const useLogout = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: logoutUser,

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['me'] });
    },

    onError: () => {
      showToast({
        variant: 'error',
        title: t('common:errors.auth.logoutFailed'),
      });
    },
  });
};

export default useLogout;
